module.exports = __webpack_public_path__ + "static/Pranav.f5d61500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Pranav.jpg
// module id = 1318
// module chunks = 137408898365125